"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const debounce_1 = __importDefault(require("debounce"));
const search_bar_styles_1 = require("./search-bar.styles");
const localization_1 = require("../../../localization");
const SearchBar = ({ searchTerm, className, onSearch, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [search, setSearch] = (0, react_1.useState)(searchTerm);
    (0, react_1.useEffect)(() => {
        setSearch(searchTerm);
    }, [searchTerm]);
    const handleSearch = (0, react_1.useMemo)(() => (0, debounce_1.default)((newSearch) => onSearch(newSearch), 500), [onSearch]);
    const handleInputChange = (e) => {
        const { value } = e.currentTarget;
        handleSearch(value);
        setSearch(value);
    };
    const handleSearchClear = () => {
        onSearch('');
        setSearch('');
    };
    return (react_1.default.createElement(search_bar_styles_1.StyledSearchInput, { onChange: handleInputChange, value: search, className: className, placeholder: `${t({ key: 'SEARCH' })}...`, startAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryBlueMed400, className: "search-icon" })), endAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, (search === null || search === void 0 ? void 0 : search.length) > 0 && (react_1.default.createElement(material_1.IconButton, null, react_1.default.createElement(ui_components_1.Icon, { onClick: handleSearchClear, variant: "cancel" })))) }));
};
exports.SearchBar = SearchBar;
